export default __webpack_public_path__ + "static/media/shades.4a2b6724.png";